import { createRouter, createWebHistory } from 'vue-router'
import BaseLayout from '@/views/Layout/Base.vue'

const routes = [
  {
    path: '/', name: 'Default', component: BaseLayout,
    children: [
      { path: '/', name: 'Home', component: () => import('../views/Home') },
      { path: '/contact', name: 'contact', component: () => import('../views/Contact') },
      { path: '/becomepartner', name: 'contact', component: () => import('../views/partner') },
    ]
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior: function (to) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
  },
})

export default router
